/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { NB_AUTH_OPTIONS } from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { NbAuthService } from '@nebular/auth';
import { NbAuthResult } from '@nebular/auth';

@Component({
  selector: 'nb-logout',
  templateUrl: './custom-logout.component.html',
})
export class NbCustomLogoutComponent implements OnInit {

  redirectDelay: number = 0;
  strategy: string = '';

  constructor(protected service: NbAuthService,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected router: Router) {
            
    this.redirectDelay = this.getConfigValue('forms.logout.redirectDelay');
    this.strategy = this.getConfigValue('forms.logout.strategy');
    this.strategy = "username";

  }

  ngOnInit(): void {
    this.logout(this.strategy);
  }

  logout(strategy: string): void {
    this.service.logout(strategy).subscribe((result: NbAuthResult) => {
    
      this.router.navigate(['auth/login']);
      const redirect = result.getRedirect();

      if (redirect) {
        setTimeout(() => {
          this.router.navigate(['auth/login']);
        }, this.redirectDelay);
      }
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/logout/custom-logout.component.ts